import React from 'react';
import PropTypes from 'prop-types';

/* eslint-disable max-len */
const Flag = (props) => {
  const { height, width, fill, stroke, className } = props;
  return (
    <svg
      id="flag"
      width={width}
      height={height}
      fill={fill}
      stroke={stroke}
      className={className}
      viewBox="0 0 50 50"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M46.976 6.2227C45.8108 5.63495 44 7.05166 43.5 7.5C40.8104 9.91167 40.2535 9.95435 38.302 9.95435C35.9002 9.95435 33.5679 8.84279 30.67 6.33187C24.3778 0.962677 18.1948 0.972602 10.9697 6.10361C10.4635 6.46089 10.4635 6.46089 10.5528 16.7924C10.5528 20.8515 10.6223 25.8833 10.5528 26.5879C10.4156 27.1187 10.7346 27.66 11.2652 27.7973C11.5843 27.8798 11.9234 27.7985 12.1705 27.5804C14.689 25.6374 17.7637 24.5523 20.9439 24.4839C23.0148 24.4952 25.0541 24.9916 26.8986 25.9329C28.9142 27.0133 31.153 27.6113 33.4389 27.6796C45.4278 27.6796 47.9206 9.83366 48 9C48.0547 8.59334 48 6.7392 46.976 6.2227Z" />
      <path d="M6.49608 0H5.56317C4.42855 0 3.50879 0.91976 3.50879 2.05439V47.9456C3.50879 49.0802 4.42855 50 5.56317 50H6.49608C7.63071 50 8.55047 49.0802 8.55047 47.9456V2.05439C8.55047 0.91976 7.63071 0 6.49608 0Z" />
    </svg>
  );
};
/* eslint-enable max-len */

Flag.defaultProps = {
  className: null,
};

Flag.propTypes = {
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  fill: PropTypes.string.isRequired,
  stroke: PropTypes.string.isRequired,
  className: PropTypes.string,
};
export default Flag;
